import { Component, OnDestroy, OnInit } from '@angular/core';
import { Device } from '../../../../models/device';
import { DataStorageService } from '../../../data-storage.service';
import { SecurityService } from '../../../security.service';
import { Location } from '@angular/common';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-edit-my-devices',
  templateUrl: './edit-my-devices.component.html',
  styleUrls: ['./edit-my-devices.component.scss']
})
export class EditMyDevicesComponent implements OnInit, OnDestroy {

  activeTab: string;
  activeTabId: number;
  device: Device;
  editNameIsDisabled: boolean;
  isCorrectPrice: boolean;

  constructor(
    public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    public api: ApiService,
    public location: Location) {
    this.device = dataStorageService.editedDevice;
    this.editNameIsDisabled = this.dataStorageService.editedDevice.parentDeviceId !== null ? true : false;
    this.isCorrectPrice = false;

    const cID = [];
    dataStorageService.categories.forEach(elem => cID.push(elem.id));
    // const categoryIndex = cID.indexOf(this.dataStorageService.currentCategoryId);
    this.activeTab = this.dataStorageService.currentCategoryName;
    this.activeTabId = this.dataStorageService.currentCategoryId;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.dataStorageService.from = null;
  }

  tabClick(tab: string, tabId: number) {
    this.activeTab = tab;
    this.dataStorageService.editedDevice.categoryId = tabId;
    this.dataStorageService.currentCategoryId = tabId;
  }

  tabDoubleClick(event: any, tabNr: number) {
    const previousValue = this.dataStorageService.categories[tabNr].name;
    const inputField = document.createElement('input');
    inputField.value = this.dataStorageService.categories[tabNr].name;
    inputField.style.width = '90%';
    inputField.addEventListener('keyup', (ev: KeyboardEvent) => {
      this.dataStorageService.categories[tabNr].name = ev.target['value'];
    });
    inputField.addEventListener('keydown', (ev) => {
      if (ev['key'] === 'Escape') {
        ev['path'][1].innerHTML = previousValue;
      } else if (ev['key'] === 'Enter' && ev.target['value'] === previousValue) {
        ev['path'][1].innerHTML = previousValue;
      } else if (ev['key'] === 'Enter' && ev.target['value'] !== previousValue) {
        ev['path'][1].innerHTML = ev.target['value'];
        const body = {
          'categories': [
            {
              'id': this.dataStorageService.categories[tabNr].id,
              'name': ev.target['value']
            }
          ]
        };
        this.api.putChangedCategoryNames(body);
      }
    });
    inputField.addEventListener('focusout', (ev) => {
      ev['path'][1].innerHTML = ev.target['value'];
    });
    inputField.addEventListener('change', (ev) => {
      ev['path'][1].innerHTML = ev.target['value'];
      const body = {
        'categories': [
          {
            'id': this.dataStorageService.categories[tabNr].id,
            'name': ev.target['value']
          }
        ]
      };
      this.api.putChangedCategoryNames(body);
    });
    event.path[0].innerHTML = '';
    event.path[0].appendChild(inputField);
    inputField.focus();
  }

  backClick() {
    this.location.back();
  }

  setLinkUrl(event) {
    this.dataStorageService.editedDevice.articleUrl = event.target.value;
  }

  setImageUrl(event) {
    this.dataStorageService.editedDevice.imageUrl = event.target.value;
  }

  setDeviceName(event) {
    this.dataStorageService.editedDevice.name = event.target.value;
  }

  setDeviceDescription(event) {
    this.dataStorageService.editedDevice.description = event.target.value;
  }

  setPurchasePrice(event) {
    const a = parseFloat(event.target.value);
    this.dataStorageService.editedDevice.purchasePrice = Math.floor(a * 100);
    if (this.dataStorageService.editedDevice.salePrice < 0) {
      this.isCorrectPrice = true;
    } else {
      this.isCorrectPrice = false;
    }
  }

  setSalePrice(event) {
    const a = parseFloat(event.target.value);
    this.dataStorageService.editedDevice.salePrice = Math.floor(a * 100);
    if (this.dataStorageService.editedDevice.salePrice < 0) {
      this.isCorrectPrice = true;
    } else {
      this.isCorrectPrice = false;
    }
  }

  onUpdate() {
    const body = {
      'name': this.dataStorageService.editedDevice.name,
      'articleUrl': this.dataStorageService.editedDevice.articleUrl,
      'description': this.dataStorageService.editedDevice.description,
      'purchasePrice': this.dataStorageService.editedDevice.purchasePrice,
      'salePrice': this.dataStorageService.editedDevice.salePrice,
      'categoryId': this.dataStorageService.editedDevice.categoryId,
      'imageUrl': this.dataStorageService.editedDevice.imageUrl,
    };
    this.api.putDevice(this.dataStorageService.editedDevice.id, body);

  }

  addNewDevice() {
    if (this.dataStorageService.editedDevice.categoryId === null) {
      this.dataStorageService.editedDevice.categoryId = this.activeTabId;
    }
    const body = {
      'articleNo': '',
      'articleUrl': this.dataStorageService.editedDevice.articleUrl,
      'name': this.dataStorageService.editedDevice.name,
      'description': this.dataStorageService.editedDevice.description,
      'manufacturer': '',
      'distributor': '',
      'purchasePrice': this.dataStorageService.editedDevice.purchasePrice,
      'salePrice': this.dataStorageService.editedDevice.salePrice,
      'visible': false,
      'imageUrl': this.dataStorageService.editedDevice.imageUrl,
      'categoryId': this.dataStorageService.editedDevice.categoryId,
      'partnerId': this.securityService.authorization.user.partnerId,
      'parentDeviceId': this.dataStorageService.editedDevice.parentDeviceId
    };
    this.api.postDevice(body).then(dev => {
      this.dataStorageService.devices.push(dev);
    });
    this.cleanUp();
  }

  cleanUp() {
    this.dataStorageService.editedDevice.articleUrl = '';
    this.dataStorageService.editedDevice.name = '';
    this.dataStorageService.editedDevice.description = '';
    this.dataStorageService.editedDevice.purchasePrice = 0;
    this.dataStorageService.editedDevice.salePrice = 0;
    this.dataStorageService.editedDevice.imageUrl = '';
  }

  saveDeviceIsDisabled() {
    if (this.dataStorageService.editedDevice.salePrice > 0 && this.dataStorageService.editedDevice.name !== '') {
      return false;
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/content/manage-my-devices/edit-my-devices/edit-my-devices.component.ts